import { render, staticRenderFns } from "./AddNominee.vue?vue&type=template&id=d2f71700&scoped=true"
import script from "./AddNominee.vue?vue&type=script&lang=js"
export * from "./AddNominee.vue?vue&type=script&lang=js"
import style0 from "./AddNominee.vue?vue&type=style&index=0&id=d2f71700&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2f71700",
  null
  
)

export default component.exports